/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BasicModel
 */
export interface BasicModel {
    /**
     * 
     * @type {number}
     * @memberof BasicModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BasicModel
     */
    name?: string | null;
}

export function BasicModelFromJSON(json: any): BasicModel {
    return BasicModelFromJSONTyped(json, false);
}

export function BasicModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasicModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function BasicModelToJSON(value?: BasicModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

